import React from 'react';
import { Route, Switch } from 'react-router-dom';

export default function Router(props) {
  const { modelsPage, optionsPage, successPaymentPage } = props;

  return (
    <Switch>
      <Route path="/:region(us|cn)/:entry(configurator|design)/:year/:model/:successType(success-payment|update-success)" component={successPaymentPage} />
      <Route exact path="/:region(us|cn)/:entry(configurator|design)/:year/:model/model" component={modelsPage} />
      <Route path="/:region(us|cn)/:entry(configurator|design)/:year/:model" component={optionsPage} />
    </Switch>
  );
}

export function SidebarRouter(props) {
  const { children: optionsSidebar, summarySidebar } = props;
  return (
    <Switch>
      <Route exact path='/:region(us|cn)/:entry(configurator|design)/:year/:model/options'>
        {optionsSidebar}
      </Route>
      <Route exact path='/:region(us|cn)/:entry(configurator|design)/:year/:model/summary' component={summarySidebar} />
    </Switch>
  )
}
